module.exports = __webpack_public_path__ + "static/media/img_sp_top.118a7b95.jpg";